const arSA = {
  'modal.close': 'إغلاق',
  'session_expired.title': 'انتهت الجلسة',
  'tokenizationForm.payment-terms.text1': 'لقد قرأت، وأفهم، وأوافق على ما يلي: أنا أُفوِّض Flywire بتخزين بطاقة الخصم/الائتمان الخاصة بي وتحصيل الرسوم منها تلقائيًا نيابة عن {{recipientName}}.',
  'tokenizationForm.general-terms.link2': 'سياسة الخصوصية',
  'tokenizationForm.general-terms.link-joint': ' و ',
  'tokenizationForm.general-terms.link1': 'شروط الاستخدام',
  'tokenizationForm.payment-terms.link': 'شروط استخدام Flywire للمدفوعات الآلية',
  'tokenizationForm.labels.cvvTooltip': '3 أرقام في الجزء الخلفي من بطاقتك أو 4 أرقام في الجزء الأمامي',
  'tokenizationForm.labels.cvv': 'CVV',
  'tokenizationForm.labels.expiryDate': 'تاريخ انتهاء الصلاحية (MM/YY)',
  'tokenizationForm.labels.cardNumber': 'رقم البطاقة',
  'tokenizationForm.labels.phone': 'رقم الهاتف',
  'tokenizationForm.labels.upopPhone': 'يُرجى إدخال رقم الهاتف المحمول المرتبط بهذه البطاقة المصرفية',
  'tokenizationForm.labels.zip': 'الرمز البريدي',
  'tokenizationForm.labels.address': 'عنوان',
  'cardsForm.labels.state': 'ولاية',
  'tokenizationForm.labels.country': 'البلد أو المنطقة',
  'tokenizationForm.labels.city': 'مدينة',
  'tokenizationForm.labels.email': 'البريد الإلكتروني',
  'tokenizationForm.labels.lastName': 'اسم العائلة',
  'tokenizationForm.labels.firstName': 'الاسم الأول',
  'cardsForm.title': 'معلومات حامل البطاقة',
  'success.title': 'أموالك في طريقها إليك',
  'success.title.info': 'يُرجى الانتظار من 2 إلى 3 أيام عمل لوصول الأموال.\nستتلقى بريدًا إلكترونيًا عند تسليم الأموال.',
  'bankAccountForm.hints.generic': 'مثال: {{label}}',
  'bankAccountForm.hints.account_number': 'يجب أن يكون طول رقم الحساب بين 1 و17 حرفًا',
  'bankAccountForm.hints.routing_number': 'يجب أن يكون طول رقم التوجيه 9 أرقام',
  'bankAccountForm.labels.accountZipCode': 'الرمز البريدي',
  'bankAccountForm.labels.accountIban': 'رقم الحساب المصرفي الدولي (IBAN)',
  'bankAccountForm.labels.accountBicCode': 'رمز BIC',
  'bankAccountForm.labels.accountNumber': 'رقم الحساب',
  'bankAccountForm.labels.accountSortCode': 'رمز الفرز',
  'bankAccountForm.labels.accountRoutingNumber': 'رقم التوجيه',
  'bankAccountForm.labels.accountType': 'نوع الحساب',
  'bankAccountForm.labels.eftProviderWidnow': 'سيتم نقلك إلى منصة معالجة المدفوعات الخاصة بالشريك لإتمام عملية الدفع هذه. بمجرد الانتهاء، سيتم إعادة توجيهك إلى هذه الصفحة مرة أخرى',
  'bankAccountForm.labels.termsFlywire': 'لقد قرأت وفهمت ووافقت على <a class=\'fw-underline fw-text-primary-600\' href=\'https://www.flywire.com/terms/\' target=\'_blank\' rel=\'noopener noreferrer\' data-testid=\'termsOfUseLink\'>شروط الاستخدام</a> <a class=\'fw-underline fw-text-primary-600\' href=\'https://www.flywire.com/privacy/\' target=\'_blank\' data-testid=\'privacyPolicyLink\' rel=\'noopener noreferrer\'>وسياسة الخصوصية</a> المعتمدة لدى Flywire',
  'bankAccountForm.labels.termsDirectDebit': 'أؤكد أنني أنا صاحب هذا الحساب والموقّع الوحيد المطلوب منه التوقيع لتفويض هذا الخصم المباشر',
  'bankAccountForm.labels.termsEft': 'لقد قرأت، وأفهم، وأوافق على <a class=\'fw-underline fw-text-primary-600\' href=\'https://opu.myonplanu.com/pdf/pad-agreement.pdf\' target=\'_blank\' rel=\'noopener noreferrer\'>اتفاقية الخصم المسبق</a>',
  'bankAccountForm.labels.city': 'المدينة',
  'bankAccountForm.labels.country': 'البلد أو المنطقة',
  'bankAccountForm.labels.selectCountry': 'اختر بلداً أو منطقة',
  'bankAccountForm.title': 'معلومات صاحب الحساب',
  'failure.tryAgain': 'حاول مرة أخرى',
  'failure.title': 'فشلت المعاملة',
  'failure.connectivity.message': 'فشلت العملية، قد يكون هذا بسبب بعض مشكلات الاتصال.',
  'failure.message': 'فشلت المعاملة. قد يكون هذا بسبب مشاكل في الاتصال. يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، يُرجى تجربة طريقة دفع أخرى أو الاتصال بالبنك الذي تتعامل معه',
  'sessionExpired.text': 'انتهت الجلسة',
  'LoadingError.title': 'حدث خطأ ما',
  'LoadingError.message': 'حدث خطأ أثناء تحميل النموذج',
  'tokenizationForm.errors.noPaymentOptionsAvailable': 'لا توجد خيارات دفع متاحة للبلد/المنطقة المحددة',
  'offerError.noOptions.card': 'The selected card type is not supported. Please use a different card type.',
  'offerError.noOptions.bank': 'The selected bank account is not supported. Please use a different bank account.',
  'offerError.noOptions.other': 'The selected Payment Method is not supported. Please use a different Payment Method.',
  'bankAccountForm.labels.accountHolderType.personal': 'الحساب الشخصي',
  'bankAccountForm.labels.accountHolderType.business': 'حساب تجاري',
  'bankAccountForm.labels.name': 'الاسم الأول',
  'bankAccountForm.labels.businessName': 'اسم النشاط التجاري',
  'bankAccountForm.labels.surname': 'اسم العائلة',
  'bankAccountForm.labels.phone': 'رقم الهاتف',
  'bankAccountForm.labels.email': 'البريد الإلكتروني',
  'bankAccountForm.labels.zip': 'الرمز البريدي',
  'bankAccountForm.labels.accountAddress': 'عنوان',
  'bankAccountForm.labels.address': 'عنوان',
  'bankAccountForm.errors.dynamicFields': '{{field}} غير صالح',
  'bankAccountForm.labels.saveButton': 'حفظ',
  'bankAccountForm.labels.nextButton': 'التالي',
  'bankAccountForm.labels.payButton': 'دفع',
  'bankAccountForm.errors.cardNumber': 'رقم البطاقة غير صالح',
  'tokenizationForm.errors.cardNumber': 'رقم البطاقة غير صالح',
  'tokenizationForm.errors.cvv': 'رقم CVV غير صالح',
  'bankAccountForm.errors.cvv': 'رقم CVV غير صالح',
  'tokenizationForm.errors.unsupportedCardTypes': 'يتم دعم {{acceptedCardsList}} فقط',
  'tokenizationForm.errors.unsupportedCardType': 'يتم دعم {{acceptedCard}} فقط',
  'tokenizationForm.errors.cardType.and': 'و',
  'tokenizationForm.errors.name': 'الاسم الأول غير صالح',
  'tokenizationForm.errors.email': 'بريد إلكتروني غير صالح',
  'tokenizationForm.errors.country': 'بلد أو منطقة غير صالحة',
  'tokenizationForm.errors.state': 'ولاية غير صالحة',
  'tokenizationForm.errors.city': 'مدينة غير صالحة',
  'tokenizationForm.errors.address': 'عنوان غير صالح',
  'tokenizationForm.errors.addressIsPoBox': 'لا نقبل عناوين صناديق البريد في حقل العنوان.',
  'tokenizationForm.errors.onlyLetterOrNumbers': 'الأحرف المسموح بها هي A-Z والأرقام من 0 إلى 9 فقط',
  'tokenizationForm.errors.onlyLetterOrNumbersOrSymbol': 'الأحرف الصالحة تشمل A-Z، 0-9 و "/, -" فقط',
  'tokenizationForm.errors.zip': 'الرمز البريدي غير صالح',
  'tokenizationForm.errors.expiryDate': 'تاريخ انتهاء الصلاحية غير صالح',
  'bankAccountForm.errors.expiryDate': 'تاريخ انتهاء الصلاحية غير صالح',
  'tokenizationForm.errors.surname': 'اسم العائلة غير صالح',
  'tokenizationForm.errors.phone': 'رقم هاتف غير صالح',
  'tokenizationForm.errors.length': 'الحقل طويل جدًا (الحد الأقصى هو 256 حرفًا)',
  'tokenizationForm.errors.required.field': 'حقل مطلوب',
  'bankAccountForm.errors.name': 'الاسم الأول غير صالح',
  'bankAccountForm.errors.name.maxSizeExceeded': 'الاسم الأول طويل جدًا (الحد الأقصى هو 140 حرفًا)',
  'form.errors.name.maxSizeExceeded': 'الاسم الأول طويل جدًا (الحد الأقصى هو {{limit}} حرفًا)',
  'form.errors.surname.maxSizeExceeded': 'اسم العائلة طويل جداً (الحد الأقصى هو {{limit}} حرفًا)',
  'form.errors.business_name.maxSizeExceeded': 'اسم النشاط التجاري طويل جدًا (الحد الأقصى هو {{limit}} حرفًا)',
  'form.errors.city.maxSizeExceeded': 'اسم المدينة طويل جدًا (الحد الأقصى هو {{limit}} حرفًا)',
  'form.errors.address.maxSizeExceeded': 'العنوان طويل جدًا (الحد الأقصى هو {{limit}} حرفًا)',
  'form.errors.date.wrongDate': 'قيمة منتقي التاريخ غير صالحة',
  'bankAccountForm.errors.business_name': 'اسم نشاط تجاري غير صالح',
  'bankAccountForm.errors.business_name.maxSizeExceeded': 'اسم النشاط التجاري طويل جدًا (الحد الأقصى هو 140 حرفًا)',
  'bankAccountForm.errors.surname': 'الاسم الأخير غير صالح',
  'bankAccountForm.errors.surname.maxSizeExceeded': 'اسم العائلة طويل جدًا (الحد الأقصى 140 حرفًا)',
  'bankAccountForm.errors.country': 'بلد أو منطقة غير صالحة',
  'bankAccountForm.errors.address': 'عنوان غير صالح',
  'bankAccountForm.errors.address.maxSizeExceeded': 'العنوان طويل جدًا (الحد الأقصى هو 256 حرفًا)',
  'bankAccountForm.errors.city': 'مدينة غير صالحة',
  'bankAccountForm.errors.city.maxSizeExceeded': 'اسم المدينة طويل جدًا (الحد الأقصى 256 حرفًا)',
  'bankAccountForm.errors.email': 'بريد إلكتروني غير صالح',
  'bankAccountForm.errors.state': 'ولاية غير صالحة',
  'bankAccountForm.errors.iban': 'رقم الحساب المصرفي الدولي (IBAN) غير صالح',
  'bankAccountForm.errors.bic': 'رمز BIC غير صالح',
  'bankAccountForm.errors.accountnumber': 'رقم حساب غير صالح',
  'bankAccountForm.errors.sortcode': 'رمز فرز غير صالح',
  'bankAccountForm.errors.account_type': 'نوع حساب غير صالح',
  'bankAccountForm.errors.addressIsPoBox': 'لا نقبل عناوين صناديق البريد في حقل العنوان.',
  'bankAccountForm.errors.onlyLetterOrNumbers': 'الأحرف المسموح بها هي A-Z والأرقام من 0 إلى 9 فقط',
  'bankAccountForm.errors.onlyLetterOrNumberOrSymbol': 'الأحرف الصالحة هي: A-Z 0-9 / , -',
  'bankAccountForm.errors.zip': 'رمز بريدي غير صالح',
  'bankAccountForm.errors.phone': 'رقم هاتف غير صالح',
  'bankAccountForm.errors.ach_account_number': 'رقم حساب غير صالح',
  'bankAccountForm.errors.routing_number': 'رقم توجيه غير صالح',
  'bankAccountForm.errors.offer': 'لا توجد خيارات دفع متاحة - إذا كان لديك حساب مصرفي في بلد/منطقة أخرى، يُرجى تحديد هذا البلد/المنطقة أو اختيار بطاقة أخرى وإعادة المحاولة. إذا لم يحل هذا المشكلة، يُرجى الاتصال بـ {{recipientName}}',
  'binLookUp.unableToFindCard.message': 'خطأ في البطاقة. يرجى مراجعة تفاصيل البطاقة التي أدخلتها أو تجربة بطاقة أخرى.',
  'binLookUp.warning.message': 'لا يمكننا التحقق من بطاقتكم',
  'confirmationPage.labels.edit': 'تعديل',
  'confirmationPage.labels.confirm': 'تأكيد',
  'confirmationPage.labels.title': 'راجع معلومات التفويض',
  'confirmationPage.labels.typeOfPayment': 'نوع الدفع',
  'confirmationPage.labels.paymentRecipient': 'مستلم الدفع',
  'confirmationPage.labels.typeOfPayment.oneOff': 'لمرة واحدة',
  'confirmationPage.labels.typeOfPayment.recurring': 'متكرر',
  'confirmationPage.labels.directDebitInformation': 'معلومات الخصم المباشر',
  'confirmationPage.labels.directDebitInformation.title': 'تعليمات إلى مصرفكم',
  'confirmationPage.labels.directDebitInformation.creditor': 'الدائن',
  'confirmationPage.labels.directDebitInformation.creditorId': 'معرف الدائن',
  'confirmationPage.labels.directDebitInformation.serviceUserStatement': 'الاسم في كشف الحساب',
  'confirmationPage.labels.directDebitInformation.serviceUserId': 'معرف مستخدم الخدمة',
  'confirmationPage.labels.directDebitInformation.address': 'عنوان Flywire',
  'confirmationPage.labels.directDebitInformation.originator': 'المنشئ',
  'confirmationPage.labels.directDebitInformation.originatorId': 'معرف المنشئ',
  'confirmationPage.labels.directDebitInformation.originatorAddress': 'عنوان المنشئ',
  'confirmationPage.labels.bankAccountInformation': 'معلومات الحساب المصرفي',
  'confirmationPage.labels.bankAccountInformation.name': 'اسم',
  'confirmationPage.labels.bankAccountInformation.iban': 'رقم الحساب المصرفي الدولي (IBAN)',
  'confirmationPage.labels.bankAccountInformation.email': 'البريد الإلكتروني',
  'confirmationPage.labels.bankAccountInformation.country': 'البلد أو المنطقة',
  'confirmationPage.labels.bankAccountInformation.state': 'الولاية',
  'confirmationPage.labels.bankAccountInformation.city': 'مدينة',
  'confirmationPage.labels.bankAccountInformation.bicCode': 'رمز BIC',
  'confirmationPage.labels.bankAccountInformation.accountNumber': 'رقم الحساب',
  'confirmationPage.labels.bankAccountInformation.sortCode': 'رمز الفرز',
  'confirmationPage.labels.bankAccountInformation.achAccountNumber': 'رقم الحساب',
  'confirmationPage.labels.bankAccountInformation.routingNumber': 'رقم التوجيه',
  'confirmationPage.labels.bankAccountInformation.accountType': 'نوع الحساب',
  'confirmationPage.labels.paymentInformation': 'معلومات الدفع',
  'confirmationPage.labels.paymentInformation.amount': 'المبلغ',
  'confirmationPage.labels.changeAccountEft': 'تغيير تفاصيل الحساب البنكي',
  'confirmationPage.labels.editPayerEft': 'تعديل تفاصيل الدافع',
  'confirmationPage.labels.useAccountEft': 'استخدم الحساب الذي ينتهي بالأرقام **** {{lastFour}}',
  'confirmationPage.labels.bankLinkSuccessMessage': 'تم ربط الحساب البنكي بنجاح',
  'confirmationPage.labels.termsSepa': 'من خلال التوقيع على نموذج التفويض هذا، فإنك تفوض (أ) شركة FLYWIRE EUROPE UAB بإرسال تعليمات إلى البنك الذي تتعامل معه للخصم من حسابك و(ب) البنك الذي تتعامل معه للخصم من حسابك وفقًا لتعليمات FLYWIRE EUROPE UAB. سيتم إعلامك قبل 3 أيام على الأقل قبل أن يتم الخصم من حسابك.',
  'confirmationPage.labels.termsBacs': 'اطلب من البنك الذي تتعامل معه أن يدفع لخدمة Direct Debits من Flywire Payments Limited من الحساب المذكور في هذه التعليمات مع مراعاة الضمانات التي يكفلها ضمان الخصم المباشر Direct Debit Guarantee. أفهم أن هذه التعليمات قد تبقى مع Flywire Payments Limited، وإذا كان الأمر كذلك، فسيتم تمرير التفاصيل إلكترونيًا إلى مصرفي/الجمعية المالية.',
  'confirmationPage.labels.termsAch': '\n     بالنقر على "تأكيد"، فإنك تؤكد أن لديك السلطة المناسبة وتفوض بموجب هذا التفويض شركة Flywire نيابةً عن المستلم المحدد\n ("المدفوع له") بالخصم من الحساب البنكي الذي قدمته أنت مقابل أي مبلغ مستحق عن الرسوم الناشئة عن استخدامك لخدمات المدفوع له\n و/أو شراء المنتجات من المدفوع له، وإذا لزم الأمر، لتصحيح عمليات الخصم الخاطئة، وفقاً لشروط المدفوع له، إلى أن يتم إلغاء هذا التفويض\n. في حالة رفض معاملة ACH بسبب عدم كفاية الأموال، أُقر أنه سيتم فرض رسوم\n على عدم كفاية الأموال، وأنه يجوز لشركة Flywire، وفقًا لتقديرها، محاولة معالجة الرسوم مرة أخرى.\n     ',
  'confirmationPage.labels.termsAch2': '\n     إذا كنت تستخدم أو تشتري منتجات و/أو خدمات إضافية من المدفوع له بشكل دوري، وفقاً لشروط المدفوع له، فإنك تفوض\n Flywire، نيابةً عن المدفوع له، بالخصم الدوري من الحساب البنكي الذي قدمته. سيتم خصم المدفوعات التي تقع خارج نطاق الخصم \nالمأذون به أعلاه فقط بعد الحصول على تفويضك عبر حسابك، أو باستخدام كلمة مرور، أو رمز، \nأو أي توقيع معادل آخر.\n     ',
  'confirmationPage.labels.termsAch3': '\n     يمكنكم إلغاء هذا التفويض في أي وقت عن طريق الاتصال بالمستفيد. يجب أن يتم استلام الإلغاء قبل [10 أيام عمل]\n على الأقل من موعد الدفع التالي المجدول.\n    ',
  'confirmationPage.labels.print': 'طباعة الاتفاقية',
  'amountPanel.labels.amountFromLabel': 'سوف تدفعون',
  'amountPanel.labels.surchargeFeeInfo': 'رسوم البطاقة مشمولة',
  'amountPanel.labels.serviceFeeInfo': 'رسوم الخدمة مشمولة',
  'amountPanel.labels.serviceFeePercentageInfo': 'رسوم الخدمة {{percentage}} (الحد الأدنى {{minimumFee}})',
  'amountPanel.labels.serviceFeePercentageOnlyInfo': '{{percentage}} رسوم الخدمة',
  'amountPanel.labels.whyThisFee': 'لماذا هذه الرسوم؟',
  'amountPanel.labels.currencyChangeWarning': 'تم تغيير العملة لتتطابق مع عملة بطاقتك',
  'amountPanel.labels.amountToLabel': '{{recipientName}} سوف يتلقى',
  'amountPanel.labels.editCurrencySelection': 'تعديل اختيار العملة',
  'amountPanel.labels.discountApplied': 'تم تطبيق خصم {{amount}}',
  'currencyInfoBanner.labels.currencyInfo': 'سيتم تحصيل الرسوم منك بعملة <b>{{code}} ({{symbol}})</b> مقابل مدفوعاتك القادمة.',
  'currencyInfoBanner.error.offerNotFound': 'لا توجد خيارات دفع متاحة.',
  'AX': 'جزر آلاند',
  'AD': 'أندورا',
  'BG': 'بلغاريا',
  'AT': 'النمسا',
  'BE': 'بلجيكا',
  'HR': 'كرواتيا',
  'CY': 'قبرص',
  'CZ': 'جمهورية التشيك',
  'DK': 'الدنمارك',
  'EE': 'إستونيا',
  'FI': 'فنلندا',
  'FR': 'فرنسا',
  'GP': 'غوادلوب',
  'DE': 'ألمانيا',
  'GR': 'اليونان',
  'HU': 'هنغاريا',
  'IS': 'أيسلندا',
  'IE': 'أيرلندا',
  'VA': 'الكرسي الرسولي (دولة مدينة الفاتيكان)',
  'IT': 'إيطاليا',
  'LI': 'ليختنشتاين',
  'LT': 'ليتوانيا',
  'LU': 'لوكسمبورغ',
  'YT': 'مايوت',
  'MT': 'مالطا',
  'MQ': 'مارتينيك',
  'ES': 'إسبانيا',
  'NO': 'النرويج',
  'NL': 'هولندا',
  'PL': 'بولندا',
  'PT': 'البرتغال',
  'SE': 'السويد',
  'RE': 'ريونيون',
  'RO': 'رومانيا',
  'CH': 'سويسرا',
  'BL': 'سانت بارتيليمي',
  'GB': 'المملكة المتحدة',
  'MC': 'موناكو',
  'MF': 'سانت مارتن (الجزء الفرنسي)',
  'PM': 'سانت بيير وميكلون',
  'SM': 'سان مارينو',
  'SK': 'سلوفاكيا',
  'SI': 'سلوفينيا',
  'GF': 'غويانا الفرنسية',
  'LV': 'لاتفيا',
  'CA': 'كندا',
  'US': 'الولايات المتحدة',
  'inlineDialogConfirmation.labels.title': 'يلزم التأكيد: إلغاء العملية',
  'inlineDialogConfirmation.labels.body': 'هل أنت متأكد من أنك تريد إلغاء هذه العملية؟',
  'inlineDialogConfirmation.labels.closeButton': 'لا',
  'inlineDialogConfirmation.labels.confirmButton': 'نعم',
  'priceBreakDown.price.toggle.button': 'تفصيل الأسعار',
  'priceBreakDown.fx.toggle.button': 'تحليل سوق العملات الأجنبية',
  'priceBreakDown.fees': 'رسوم',
  'priceBreakDown.service_fees': 'رسوم الخدمة',
  'priceBreakDown.card_fees': 'رسوم البطاقة',
  'priceBreakDown.exchange.rate': 'سعر الصرف',
  'priceBreakDown.markup.rate': 'هامش الربح من سعر البنك المركزي الأوروبي',
  'priceBreakDown.discount': 'خصم',
  'priceBreakDown.discount.coupon': 'خصم ({{code}})',
  'priceBreakDown.original_amount': 'المبلغ الأصلي',
  'priceBreakDown.total': 'المجموع',
  'acceptProposedOfferBanner.textInfo': 'هذه البطاقة غير مؤهلة. اضغط على "قبول" للمتابعة إلى طرق الدفع المدعومة أو ',
  'acceptProposedOfferBanner.textInfoWithoutChangeCard': 'هذه البطاقة غير مؤهلة. اضغط على "قبول" للمتابعة إلى طرق الدفع المدعومة.',
  'acceptProposedOfferBanner.link.option': 'تغيير البطاقة',
  'acceptProposedOfferBanner.labels.accept': 'قبول',
  'chooseCurrencyBanner.title': 'اختر العملة',
  'chooseCurrencyBanner.message': 'تختلف عملة بطاقتك عن عملة بلد الفوترة. يُرجى تحديد العملة التي تريد استخدامها لهذه المعاملة:',
  'banner.offer.validation.message': 'عليك أن تختار إجراء للاستمرار.',
  'instructions.offline.amount.label': 'المبلغ المطلوب دفعه',
  'instructions.offline.reference.label': 'الرقم المرجعي/معرف الدفع',
  'instructions.offline.paymentId.label': 'معرف الدفع',
  'instructions.offline.paymentReferenceMissing': 'مرجع الدفع غير موجود',
  'instructions.offline.missing.title': 'تعذر إنشاء تعليمات الدفع الخاصة بك',
  'instructions.offline.missing.message': 'يرجى المحاولة مرة أخرى. إذا استمرت المشكلة، يُرجى تجربة طريقة دفع أخرى أو الاتصال بالبنك الذي تتعامل معه.',
  'instructions.offline.title': 'تعليمات الدفع',
  'instructions.offline.understand': 'أفهم أنني بحاجة إلى بدء عملية تحويل من حسابي المصرفي.<br />انقر هنا للإغلاق.',
  'instructions.offline.download.button': 'قم بتنزيل تعليمات التحويل البنكي',
  'instructions.offline.howToBankTransfer': 'كيفيّة إجراء تحويل بنكي؟',
  'instructions.offline.howToBankTransfer.modal.title': 'كيفية إتمام تحويلك البنكي',
  'instructions.offline.howToBankTransfer.modal.intro': 'فيما يلي خيارات مختلفة يمكنك استخدامها لإتمام عملية التحويل البنكي:',
  'instructions.offline.howToBankTransfer.modal.onlineBankingTitle': 'الخدمات المصرفية عبر الإنترنت / الخدمات المصرفية عبر الهاتف المحمول',
  'instructions.offline.howToBankTransfer.modal.onlineBankingDescription': 'إذا كانت لديك خدمة مصرفية عبر الإنترنت أو تطبيق جوال من البنك الذي تتعامل معه، فيمكنك بسهولة تسجيل الدخول إلى حسابك وإجراء التحويل بنفسك.',
  'instructions.offline.howToBankTransfer.modal.inPersonTitle': 'زيارة شخصية إلى فرع البنك',
  'instructions.offline.howToBankTransfer.modal.inPersonDescription': 'من خلال القيام بزيارة شخصية إلى فرع البنك المحلي الخاص بك، يمكنك تقديم تفاصيل الحساب البنكي المطلوبة الموجودة في تعليمات الدفع الخاصة بك من أجل إجراء التحويل.',
  'instructions.offline.howToBankTransfer.modal.telephoneTitle': 'تحويل عبر الهاتف',
  'instructions.offline.howToBankTransfer.modal.telephoneDescription': 'يمكنك أيضاً الاتصال بالبنك الذي تتعامل معه وتفويضه لبدء المعاملة نيابة عنك.',
  'instructions.offline.referenceWarning': 'يجب عليك تضمين هذا المرجع حتى نتمكن من تحديد عملية الدفع الخاصة بك',
  'instructions.offline.dueDateLabel': 'يرجى تحويل الأموال قبل:',
  'instructions.offline.processingTime': 'ستستلم Flywire الأموال بعد <strong>يومَي عمل إلى 3 أيام عمل</strong> من بدء التحويل.',
  'elementsInstructions.qr.description': 'امسح رمز الاستجابة السريعة (QR) لإتمام عملية الدفع.',
  'elementsInstructions.qr.payid.description': 'Open your banking app and send to the PayID below. This address is assigned exclusively to your account — payments are matched automatically.',
  'elementsInstructions.qr.scan': 'أو امسح باستخدام كاميرا هاتفك',
  'elementsInstructions.qr.waitingForPayment': 'Awaiting payment completion',
  'elementsInstructions.externalAction.generic': 'يرجى إكمال عملية الدفع للمتابعة.',
  'elementsInstructions.externalAction.mpesa_message_finish_payment_on_phone': 'تم إرسال طلب دفع M-Pesa إلى هاتفك.\nيرجى إكمال عملية الدفع للمتابعة.',
  'elementsInstructions.redirect.title': 'Complete your payment',
  'elementsInstructions.redirect.description': 'You will be taken to the partner\'s processing platform to complete this payment. Once it is done, you will be redirected to this page again.',
  'elementsInstructions.redirect.button': 'Make your payment',
  'documentCollector.collapsibleTitle': 'تحميل المستندات',
  'documentCollector.uploadingDocument': 'تحميل المستند',
  'documentCollector.deleteFile': 'حذف {{fileName}}',
  'documentCollector.deletingFile': 'حذف {{fileName}}',
  'documentCollector.moreInfoModal': 'مزيد من المعلومات',
  'documentCollector.errorsModal': 'Document warnings',
  'documentCollector.documentList': 'قائمة المستندات',
  'documentCollector.upload': 'تحميل',
  'documentCollector.errorBlockLabel': 'Document warnings',
  'documentCollector.reUpload': 'إعادة التحميل',
  'documentCollector.errorsFoundOne': '{{count}} Warning Found',
  'documentCollector.errorsFoundOther': '{{count}} Warnings Found',
  'documentCollector.validationNote': '<b>اكتمل تحميل الملف!</b> رصد الفحص الآلي لدينا مشكلات محتملة. إذا كان مستندك يتضمن جميع المعلومات المطلوبة، فتجاهل هذا التحذير.',
  'documentCollector.antivirus': 'فحص الملفات ببرنامج مكافحة الفيروسات',
  'documentCollector.antivirusStep': 'فحص الملفات ببرنامج مكافحة الفيروسات 1/2',
  'documentCollector.verifyingStep': 'التحقق من المستندات 2/2',
  'documentCollector.invalidFile': 'تم اكتشاف ملف غير صالح. قد يكون الملف محميًا بكلمة مرور أو مشفرًا. يرجى التحقق والمحاولة مرة أخرى.',
  'documentCollector.moreInfo': 'مزيد من المعلومات',
  'documentCollector.required': 'مطلوب',
  'documentCollector.review': 'مراجعة',
  'documentCollector.acceptedFileTypes': 'أنواع الملفات المقبولة: <b>PDF</b> و <b>PNG</b> و <b>JPG</b>',
  'documentCollector.maxFileSize': 'الحد الأقصى لحجم الملف: <b>{{maxFileSize}}ميجابايت.</b>',
  'documentCollector.acceptedFileAndFileSize': 'أنواع الملفات المقبولة: <b>PDF</b> و <b>PNG</b> و <b>JPG</b>. الحد الأقصى لحجم الملف: <b>{{maxFileSize}}ميجابايت.</b>',
  'documentCollector.docVerifyError.missingInfo': 'يرجى التأكد من أن المستند يحتوي على جميع المعلومات المطلوبة.',
  'documentCollector.docVerifyError.documentTypeError': 'لا يبدو هذا من النوع {{documentType}}. يُرجى التحقق من المتطلبات وتحميل ملف جديد إن لزم الأمر.',
  'documentCollector.docVerifyError.documentIdentificationTypeError': 'المستند الذي تم تحميله لا يبدو نوعه {{documentType}}، وهو نوع بطاقة الهوية الذي حددته لعملية الدفع هذه. يرجى التحقق وإعادة التحميل إن لزم الأمر.',
  'documentCollector.docVerifyError.documentType.errorNote': '<b>ملاحظة</b>: تقديم مستندات غير صحيحة يمكن أن يسبب تأخيرات في معالجة الدفع. إذا كانت وثائقك سارية المفعول، يرجى تجاهل هذه الملاحظة التحذيرية.',
  'documentCollector.duplicateFile': 'تم اكتشاف مستند مكرر. يُرجى تحميل ملف مختلف لكل مستند.',
  'oneOff.savePaymentMethod.label': 'حفظ طريقة الدفع هذه للمدفوعات المستقبلية',
  'lrs.transaction.title': 'المعاملة',
  'lrs.transaction.date': 'التاريخ',
  'lrs.transaction.amount': 'المبلغ',
  'lrs.transaction.amountHint': 'المبلغ بالعملة الأجنبية',
  'lrs.transaction.adBranch': 'اسم وعنوان فرع AD',
  'lrs.transaction.add': 'يرجى إضافة المزيد من المعاملات',
  'lrs.signatureModal.title': 'توقيع المستند',
  'lrs.signatureModal.tab.draw': 'رسم التوقيع',
  'lrs.signatureModal.tab.upload': 'تحميل التوقيع',
  'lrs.signatureModal.draw.text': 'يرجى التوقيع في المكان المخصص أدناه باستخدام الماوس أو الإصبع لقبول المستند.',
  'lrs.signatureModal.legalAlert': 'التوقيعات غير الصحيحة ستبطل جميع عمليات LRS. يرجى التأكد من التوقيع باستخدام <b>توقيع حامل PAN</b>. سيتم إرسال نسخة من المستند إلى البريد الإلكتروني الخاص بالدافع المذكور لاستخدامها في المستقبل إذا لزم الأمر. أنواع الملفات المقبولة: <b>PNG</b> و<b>JPG</b>.',
  'lrs.signatureModal.draw.clear': 'مسح',
  'lrs.signatureModal.upload.label': 'تحميل نسخة مصورة من توقيعك',
  'lrs.signatureModal.upload.input': 'تحميل التوقيع',
  'lrs.signatureModal.upload.remove': 'إزالة',
  'lrs.signatureModal.upload.hint': 'أنواع الملفات المقبولة: <b>PNG</b> و <b>JPG</b>. الحد الأقصى لحجم الملف: <b>8 ميجابايت</b>',
  'lrs.signatureModal.upload.typeError': 'نوع الملف غير مدعوم. يرجى تحميل ملف بتنسيق PNG أو JPG.',
  'lrs.signatureModal.upload.sizeError': 'يجب أن يكون حجم الملف أقل من 8 ميجابايت',
  'lrs.signatureModal.upload.readError': 'تعذر قراءة الملف. يرجى المحاولة مرة أخرى.',
  'lrs.signatureModal.confirm': 'قبول وإرسال',
  'lrs.signatureModal.previewError': 'حدث خطأ ما أثناء إنشاء المعاينة. يرجى المحاولة مرة أخرى.',
  'lrs.signatureModal.uploadError': 'حدث خطأ ما أثناء الإرسال. يرجى المحاولة مرة أخرى.',
  'lrs.previewLink.label': 'معاينة المستند',
  'lrs.documents.continueButton': 'تابع لإرسال نموذج LRS',
  'lrs.form.declaration': 'تحت مخطط التحويلات الميسرة (LRS)، تطلب الحكومة الهندية وبنك الاحتياطي الهندي (RBI) الآن نموذج إعلان LRS (المسمى بالكامل &quot;إعلان A2 cum LRS&quot;) لتحويل الأموال إلى الخارج. من الضروري إرسال إقرار LRS الخاص بك قبل بدء التحويل البنكي، وإلا فقد يواجه دفعك تأخيرات في المعالجة. لمزيد من التفاصيل حول كيفية إكمال هذه الخطوة، انقر <a href=\'https://help.flywire.com/hc/en-us/articles/360012963774\' target=\'_blank\'>هنا</a> لمعرفة المزيد.',
  'lrs.form.bankAccountAndStudentInfo.title': 'معلومات الحساب البنكي ومعلومات الطالب',
  'lrs.form.bankAccountAndStudentInfo.text': 'يرجى تحديد الحساب البنكي الذي سيتم تحويل الأموال منه. إذا كنت قد حصلت على قرض تعليمي وسيتم صرف الأموال من حساب القرض الخاص بك، يرجى تقديم رقم حساب القرض. لا تُقبل التحويلات من حسابات NRO/NRE. بالنسبة لمعرف الطالب، يمكنك استخدام معرف الطالب أو معرف الطلب أو الرقم المرجعي.',
  'lrs.form.details.title': 'تفاصيل المعاملات الدولية التي تمت في السنة المالية الحالية',
  'lrs.form.details.text': 'يرجى تقديم تفاصيل أي معاملات بالعملات الأجنبية التي قمت بها خلال السنة المالية الحالية (<b>أبريل {{startYear}} - مارس {{endYear}}</b>). اترك الحقل فارغاً إذا لم تكن قد قمت بأي معاملات.',
  'lrs.form.bankAccountNumber': 'رقم الحساب البنكي',
  'lrs.form.studentFullName': 'اسم الطالب الكامل',
  'lrs.form.studentId': 'هوية الطالب',
  'lrs.form.required': 'مطلوب',
  'lrs.form.signAndSubmit': 'يرجى توقيع وإرسال نموذج LRS',
  'lrs.title': 'قم بتحميل المستندات وتقديم نموذج LRS',
  'lrs.description': 'ستظهر لك تعليمات تحويل الأموال عبر البنك بمجرد إتمام هذه الخطوة.',
  'lrs.tabs.documents': '1. رفع المستندات',
  'lrs.tabs.form': '2. إرسال نموذج LRS',
  'recipientFields.requiredField': '(*) حقل مطلوب',
  'paymentMethodSelector.loading': 'جارٍ تحميل طرق الدفع...',
  'paymentMethodSelector.cards.acceptsDebitAndCredit': 'يقبل بطاقات الخصم والائتمان',
  'paymentMethodSelector.cards.acceptsDebitOnly': 'يقبل بطاقات الخصم',
  'paymentMethodSelector.cards.acceptsCreditOnly': 'يقبل بطاقات الائتمان',
  'paymentMethodSelector.cards.surchargeWarning': 'قد تُطبق رسوم إضافية اعتمادًا على نوع البطاقة وبلد الإصدار.',
  'paymentMethodSelector.subtitle.default': 'ادفع باستخدام {{methodName}}',
  'paymentMethodSelector.subtitle.google_pay': 'ادفع باستخدام محفظة Google Pay المحفوظة',
  'paymentMethodSelector.subtitle.apple_pay': 'Touch ID أو Face ID — Safari فقط',
  'paymentMethodSelector.subtitle.paypal': 'ادفع باستخدام حساب PayPal الخاص بك',
  'paymentMethodSelector.subtitle.wechat': 'الدفع عبر WeChat — متاح في البر الرئيسي للصين',
  'paymentMethodSelector.subtitle.alipay': 'ادفع باستخدام Alipay',
  'paymentMethodSelector.subtitle.trustly': 'الدفع عبر الخدمات المصرفية المفتوحة'
} as const;
export { arSA };
